import { UseQueryOptions } from 'react-query'
import { PostHelpQuestionResponse, postHelpQuestion } from './helpPanel'

const HELP_QUESTION_QUERY_KEY = 'helpQuestion'

export function postHelpQuestionQuery(query: string): UseQueryOptions<PostHelpQuestionResponse, Error> {
  return {
    queryKey: [HELP_QUESTION_QUERY_KEY, query],
    queryFn: () => postHelpQuestion(query),
    retry: false,
    staleTime: Infinity
  }
}
